import { useTranslation } from 'react-i18next';

export default function CaseStudies() {
  const { t } = useTranslation();

  const cases = [
    {
      title: t('case1_title'),
      description: t('case1_desc'),
      scope: t('case1_scope'),
      deliverables: t('case1_deliverables'),
      image: 'https://public.readdy.ai/ai/img_res/0e5b0e59ab99c23a9a1f28116421c5ea.jpg'
    },
    {
      title: t('case2_title'),
      description: t('case2_desc'),
      scope: t('case2_scope'),
      deliverables: t('case2_deliverables'),
      image: 'https://readdy.ai/api/search-image?query=Detailed%20slope%20analysis%20diagram%20showing%20gradient%20zones%20and%20buildable%20areas%20on%20Sicilian%20terrain%2C%20professional%20engineering%20visualization%20with%20color-coded%20elevation%20zones%2C%20technical%20site%20planning%20documentation%20for%20development%20assessment&width=800&height=600&seq=case-002&orientation=landscape'
    },
    {
      title: t('case3_title'),
      description: t('case3_desc'),
      scope: t('case3_scope'),
      deliverables: t('case3_deliverables'),
      image: 'https://readdy.ai/api/search-image?query=Professional%20due%20diligence%20documentation%20with%20land%20survey%20reports%2C%20regulatory%20compliance%20documents%2C%20and%20site%20assessment%20data%20for%20Sicilian%20property%2C%20clean%20organized%20technical%20paperwork%20and%20analysis%20charts%20for%20land%20acquisition%20review&width=800&height=600&seq=case-003&orientation=landscape'
    }
  ];

  return (
    <section id="case-studies" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('cases_title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('cases_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cases.map((caseStudy, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300 border border-gray-100"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={caseStudy.image}
                  alt={caseStudy.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4">
                  {caseStudy.title}
                </h3>
                <div className="space-y-3 text-sm">
                  <div>
                    <p className="text-gray-600">{caseStudy.description}</p>
                  </div>
                  <div>
                    <strong className="text-gray-900">{t('case_scope_label')}</strong>
                    <p className="text-gray-600 mt-1">{caseStudy.scope}</p>
                  </div>
                  <div>
                    <strong className="text-gray-900">{t('case_deliverables_label')}</strong>
                    <p className="text-gray-600 mt-1">{caseStudy.deliverables}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
